import React from 'react';
import { connect } from 'react-redux';
import { getCornerHulls, getHandles, getWardrobeHulls } from '../../store/actions/products';
import { getDimensions } from '../../store/actions/dimensions';
import { getToken } from '../../store/actions/token';
import { reactLocalStorage } from 'reactjs-localstorage';

const CloseConfiguratorPopup = props => {
  const reloadData = () => {
    props.getToken();
    props.getDimensions();
    props.getHandles();
    props.getWardrobeHulls();
    props.getCornerHulls();
  };

  const historyPath = reactLocalStorage.get('historyPath', 'https://www.brw.pl/', true);

  const closePopup = e => {
    const popup = e.target.closest(`[data-popup-name="close-configurator"]`);
    if (document.body.classList.contains('overlay')) {
      document.body.classList.remove('overlay');
    }
    popup.classList.remove('open');
    localStorage.clear();
    reloadData();

    window.location.replace(historyPath);
  };

  return (
    <>
      <p>Zamykając konfigurator utracisz wszystkie szafy</p>
      <div className="pop-up__buttons">
        <button className="button clean-accessories__button" onClick={closePopup}>
          OK
        </button>
      </div>
    </>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    getToken: () => dispatch(getToken()),
    getHandles: () => dispatch(getHandles()),
    getDimensions: () => dispatch(getDimensions()),
    getWardrobeHulls: () => dispatch(getWardrobeHulls()),
    getCornerHulls: () => dispatch(getCornerHulls()),
  };
};

export default connect(null, mapDispatchToProps)(CloseConfiguratorPopup);
